import { Link } from 'react-router';
import { Button } from '../components/ui';

export function NotFound() {
  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center">
      <p className="font-mono text-gold-text">404</p>
      <h1 className="mt-2 text-3xl">This office is empty.</h1>
      <p className="mt-3 text-silver">The page you're looking for doesn't exist.</p>
      <Link to="/" className="mt-8 inline-block">
        <Button variant="outline">Back to the lobby</Button>
      </Link>
    </div>
  );
}
